import { useFormikContext } from "formik";
import _ from "lodash";
import React, { useContext, useEffect} from "react";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import CsplDragDrop from "../../CsplControls/CsplDragDrop/CsplDragDrop";

function SignatureUpload() {
  const applicationContext = useContext(KycApplicationContext);
  let isDisabled = applicationContext.disableForm;
  const { values, setFieldValue,setTouched } = useFormikContext();

  //initialize tax declaration countries
  useEffect(() => {
    if (
       values.personalInfoDTO.signatureUploadDTO == null || values.personalInfoDTO.signatureUploadDTO == undefined
    ) {
      setFieldValue("personalInfoDTO.signatureUploadDTO",{});
    }

  }, []);

  return (
    <React.Fragment>
      <div className="content_body">
        <div className="row">
          <div className="col-xl-7 col-lg-8 col-sm-10 col-12 mx-auto">
              <CsplDragDrop
              label={"label.Signature-upload"}
              required={true}
              disabled={isDisabled}
              base64FieldName={"personalInfoDTO.signatureUploadDTO.signatureImage"}
              fileNameFieldName={"personalInfoDTO.signatureUploadDTO.signatureFileName"} 
              path={"personalInfoDTO.signatureUploadDTO.signatureImagePath"}
              ></CsplDragDrop>
          </div>         
        </div>
      </div>
    </React.Fragment>
  );
}

export default SignatureUpload;

